import '@mdi/font/css/materialdesignicons.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import { colors } from '@/config/colors'

import Vue from 'vue'
import Vuetify from 'vuetify'

Vue.use(Vuetify)

/* Use named theme colors in scss files via var(--v-<color name from theme>-base) */
const opts = {
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        'primary': colors['green'],
        'primary-variant': colors['green'],
        'secondary': colors['green'],
        'secondary-variant': colors['black'],
        'accent': colors['green'],

        'main': colors['gray'],
        'main-darken-1': colors['dove-gray'],
        'main-darken-2': colors['emperor'],
        'main-darken-3': colors['tundora'],
        'main-darken-4': colors['cod-gray'],
        'main-darken-5': colors['black'],
        'main-lighten-1': colors['silver-chalice'],
        'main-lighten-2': colors['silver'],
        'main-lighten-3': colors['gallery'],
        'main-lighten-4': colors['concrete'],
        'main-lighten-5': colors['white'],

        'error': colors['guardsman-red'],
        'gallery': colors['green'],
        'info': colors['dodger-blue'],
        'success': colors['mantis'],
        'warning': colors['amber'],
        'search-input-bg': colors['mercury'],
        'search-bar-bg': colors['black'],
      },
    },
  },
  icons: {
    iconfont: 'md',
  },
}

export default new Vuetify(opts)
